import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isValidLegalForm',
  standalone: false,
})
export class IsValidLegalFormPipe implements PipeTransform {
  transform(code: string): boolean {
    if (!code) {
      return false;
    }

    code = code.replace('JF', '');
    return (
      code === '51' ||
      code === '53' ||
      code === '54' ||
      code === '61' ||
      code === '94'
    );
  }
}
